import BoxImage from "@components/BoxImage";
import BoxUrlOrFile from "@components/BoxUrlOrFile";
import ButtonContainer from "@components/ButtonContainer";
import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import Player from "@components/Player";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import useAwardVideo from "@hooks/Award/useAwardsVideo";
import useUpdateItem from "@hooks/Shared/useUpdateItem";
import awardVideoItemMapper from "@mappers/Modules/award/AwardVideoItem.mapper";
import updateAwardVideo from "@services/Award/updateAwardVideo";
import awardVideoValidate from "@validators/Modules/award/awardVideo.validate";
import { ReactElement, useEffect, useRef } from "react";
import { Form } from "react-final-form";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import styles from "./AwardVideo.module.scss";

const AwardVideo = (): ReactElement => {
  const { data, isLoading, handleCallApi } = useAwardVideo();
  const {
    isUpdating,
    isModalOpen,
    handleSaveForm,
    handleUpdate,
    handleIsModalOpen,
  } = useUpdateItem();
  const formRef = useRef<any>(null);

  useEffect(() => {
    // To reset form fields after update
    formRef.current && formRef.current.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formRef.current]);

  return (
    <Container>
      <ModalConfirmation
        icon="plus-circle"
        title={`Video | Update Video Confirmation`}
        body={`Are you sure you want to update the Award's Video?`}
        handleConfirm={() => {
          data?.uuid &&
            handleUpdate(updateAwardVideo, data?.uuid, handleCallApi);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.WARNING}
      />
      <Title />
      <Row>
        <Col xs={12} md={12} lg={12} xl={10}>
          <Card>
            <CardBody>
              {isUpdating || isLoading ? (
                <Loader isInsideThing />
              ) : (
                <Form
                  onSubmit={(FormValues) => {
                    handleSaveForm(FormValues, awardVideoItemMapper);
                  }}
                  validate={awardVideoValidate}
                  ref={formRef}
                >
                  {({ handleSubmit }) => (
                    <form
                      className={`${styles.form} form form--horizontal`}
                      onSubmit={handleSubmit}
                    >
                      <Col md={6} className={styles.leftColumn}>
                        <BoxUrlOrFile section={data ? "modify" : "create"} />

                        <div className={styles.buttonsContainer}>
                          <ButtonContainer />
                        </div>
                      </Col>

                      <Col md={6}>
                        {data?.mediaUrl ? (
                          <Player title="Video" media={data?.mediaUrl} />
                        ) : (
                          // To show the default image when there's no video
                          <BoxImage title="Video" />
                        )}
                      </Col>
                    </form>
                  )}
                </Form>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AwardVideo;
